import ReactTooltip from 'react-tooltip-lite'
import React, { CSSProperties, FunctionComponent, memo, ReactNode } from 'react'
import { useQueries } from '../../utils/hooks/useQueries'

type Direction = 'up' | 'up-start' | 'up-middle' | 'up-end' | 'down' | 'down-start' | 'down-middle' |
    'down-end' | 'left' | 'left-start' | 'left-middle' | 'left-end' | 'right' | 'right-start' | 'right-middle' | 'right-end'

export type TooltipTitle = string | {
    disable?: boolean,
    content?: ReactNode,
    direction?: Direction,
}

export interface TooltipProps {
    className?: string,
    title?: TooltipTitle,
    styles?: CSSProperties,
    children: ReactNode,
}

const Tooltip: FunctionComponent<TooltipProps> = props => {
    const { isMobile } = useQueries()

    return <ReactTooltip
        className={props.className}
        tipContentClassName={''}
        useDefaultStyles
        hoverDelay={0.1}
        useHover={!isMobile && !!(typeof props.title === 'object' ? (props.title.content && !props.title.disable): props.title)}
        direction={typeof props.title === 'object' ? props.title.direction : undefined}
        content={(typeof props.title === 'object' ? props.title?.content: props.title) || ' '}
        styles={props.styles}
    >
        {props.children}
    </ReactTooltip>
}

Tooltip.whyDidYouRender = true

export default memo(Tooltip)